import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { GridContainer, GridItem, LoadingOverlay } from "@insite/mobius/index";
import React from "react";
import { GridItemProps } from "@insite/mobius/GridItem";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import Zone from "@insite/client-framework/Components/Zone";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { ResolveThunks, connect } from "react-redux";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";

const mapStateToProps = (state: CustomApplicationState) => ({
    isLoading: state.ADIGlobalData.ADIRMAStatusStore.isLoading,
    isAuthenticated: state.context.session.isAuthenticated,
    location: getLocation(state),
    search: getLocation(state),
    pathname: getLocation(state),

});
const mapDispatchToProps = {};

export interface ADIDealerInfoContainerStyles {
    container?: GridContainerProps;
    RMAStatusHistoryGridItem?: GridItemProps;
}

export const adiDealerInfoContainerStyles: ADIDealerInfoContainerStyles = {
    container: {
        gap: 0,
    },
    RMAStatusHistoryGridItem: {
        width: [12, 12, 12, 12, 12],
    },
};

const styles = adiDealerInfoContainerStyles;

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const RMAStatusHistoryContainer = ({ id, isLoading, isAuthenticated, location, search, pathname }: Props) => {

    React.useEffect(() => {
        if (!isAuthenticated && location.pathname.includes("MyAccount")) {
            const returnUrl = location.pathname;
            window.location.href = `/MyAccount/SignIn?returnUrl=${encodeURIComponent(returnUrl)}`;
        }
    }, [isAuthenticated]);
    return (
        <>
        
            <LoadingOverlay loading={isLoading}>
            { isAuthenticated && (
                <GridContainer {...styles.container}>
                    <GridItem {...styles.RMAStatusHistoryGridItem}>
                        <Zone zoneName="RMASHFilterSearch" contentId={id} />
                    </GridItem>
                    <GridItem {...styles.RMAStatusHistoryGridItem}>
                        <Zone zoneName="RMASHPaginationTop" contentId={id} />
                    </GridItem>
                    <GridItem {...styles.RMAStatusHistoryGridItem}>
                        <Zone zoneName="RMASHTable" contentId={id} />
                    </GridItem>
                    <GridItem {...styles.RMAStatusHistoryGridItem}>
                        <Zone zoneName="RMASHPaginationBottom" contentId={id} />
                    </GridItem>
                </GridContainer>
)}
            </LoadingOverlay>      
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RMAStatusHistoryContainer),
    definition: {
        group: "Basic",
        displayName: "ADI RMA Status History Container",
    },
};

export default widgetModule;
